import { gql } from '@apollo/client';

export const ON_READER_FIRMWARE_UPDATE = gql`
  subscription OnReaderFirmwareUpdate($doorId: ID!) {
    onReaderFirmwareUpdate(doorId: $doorId) {
      doorId
      status
      percentage
    }
  }
`;
